import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter011() {
  return <KbChapterPage slug="chapter-011" />;
}

(Chapter011 as unknown as { path: string }).path = "/theory-album/011";
